import { Tabs, TabsProps } from "antd";
import { PageCard } from "src/common/styles/styles";
import { ContractConfirmationComponent } from "src/features/ServiceContract/CreateServiceContract/ContractConfirmation/ContractConfirmationComponent";
import { useParams } from "react-router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ServiceContractError } from "../state/types";
import { RootState } from "src/state/reducer";
import { serviceLoading } from "src/common/apiLoader/state/selection";
import { GET_CONTRACT_BY_ID_API } from "../state/actionTypes";
import InnerLoader from "src/components/InnerLoader";
import { getActivityLogActionLabel, TimeLine } from "src/components/TimeLine";
import { ActivityLog, ActivityLogType } from "src/common/models/activityLog";
import { GET_ACTIVITY_LOG_RECORDS_API } from "src/common/state/actionTypes";
import { formatToDisplayDatetime } from "src/common/util";
import { getActivityLogRecordsApi } from "src/common/state/action";
import { SystemDescriptions } from "src/common/descriptions";
import { ServiceContract } from "src/common/models/contract";
import { getServiceContractByIdApi } from "../state/action";
import { ContractPaymentComponent } from "src/features/CustomerPayment/ContractPaymentComponent";
import { ServiceContractDebitsComponent } from "src/features/ServiceContractDebit/ServiceContractDebitsComponent";

interface ReduxProps {
    error?: ServiceContractError
    isGettingContract: boolean
    currentContract?: ServiceContract
    isGettingActivityLog: boolean
    activityLogs?: ActivityLog[]
}

export const ServiceContractDetail = () => {
    const dispatch = useDispatch()

    const { id: serviceContractId } = useParams<{ id: string }>();

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.SERVICE_CONTRACTS

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        error: state?.serviceContract.error,
        isGettingContract: serviceLoading(state, [GET_CONTRACT_BY_ID_API]),
        currentContract: state.serviceContract.currentContract as ServiceContract,
        isGettingActivityLog: serviceLoading(state, [GET_ACTIVITY_LOG_RECORDS_API]),
        activityLogs: state.common.activityLogs,
    }))

    useEffect(() => {
        if (serviceContractId) {
            dispatch(getServiceContractByIdApi(Number(serviceContractId)))
            dispatch(getActivityLogRecordsApi({
                ref: serviceContractId,
                type: ActivityLogType.SERVICE_CONTRACT,
            }))
        }
    }, [])

    const items: TabsProps['items'] = [
        {
            key: 'INFO',
            label: descriptions.DATA.TAB_DETAIL,
            children: reduxProps.currentContract
                ? <ContractConfirmationComponent
                    currentContract={reduxProps.currentContract}
                    type={"SERVICE_CONTRACT"}
                />
                : <InnerLoader />
            ,
        },
        {
            key: 'SERVICE_CONTRACT_DEBITS',
            label: descriptions.DATA.TAB_SERVICE_CONTRACT_DEBITS,
            children: <ServiceContractDebitsComponent serviceContractId={Number(serviceContractId)} />
            ,
        },
        {
            key: 'SERVICE_CONTRACT_PAYMENTS',
            label: descriptions.DATA.TAB_SERVICE_CONTRACT_PAYMENTS,
            children: <ContractPaymentComponent serviceContractId={Number(serviceContractId)} />
            ,
        },
        {
            key: 'ACTIVITY_LOG',
            label: descriptions.DATA.TAB_ACTIVITY_LOG,
            children: reduxProps.activityLogs
                ? <TimeLine
                    records={reduxProps.activityLogs.map(log => {
                        return {
                            description: getActivityLogActionLabel(log.action),
                            date: formatToDisplayDatetime(log.datetime),
                            type: log.action,
                        }
                    })}
                />
                : <InnerLoader />
        },
    ];

    const renderTabs = () => (
        <Tabs defaultActiveKey="INFO" items={items} />
    )

    return (
        < PageCard
            size="small"
            title={descriptions.TITLE}
        >
            {renderTabs()}
        </PageCard>
    )
}
